(function () {
  'use strict';

  var root = null;
  var drawer = null;
  var overlay = null;
  var refreshing = false;
  var lastFocus = null;

  function qs(sel, el) {
    return (el || document).querySelector(sel);
  }

  function qsa(sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  }

  function cartRoutes() {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      root: rootPath,
      add: rootPath + 'cart/add.js',
      change: rootPath + 'cart/change.js',
      cart: rootPath + 'cart.js',
      sections: rootPath + '?sections=cart-drawer'
    };
  }

  function isOpen() {
    return drawer && drawer.classList.contains('is-open');
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('cart-drawer-open', lock);
    document.body.classList.toggle('cart-drawer-open', lock);
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    // force reflow so transition runs
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var closeBtn = qs('[data-cart-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    window.setTimeout(function () {
      if (!isOpen()) overlay.hidden = true;
    }, 300);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function updateHeaderCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    qsa('[data-cart-open]').forEach(function (el) {
      var label = el.getAttribute('data-cart-label') || 'Cart';
      // Keep accessible name fresh when only the count span is present
      el.setAttribute('aria-label', label + ' — ' + count + ' items');
      el.classList.toggle('has-items', count > 0);
    });
  }

  function bindRoot(el) {
    root = el;
    drawer = qs('[data-cart-drawer]', root);
    overlay = qs('[data-cart-drawer-overlay]', root);
  }

  async function refreshDrawer(openAfter) {
    if (refreshing) return;
    refreshing = true;
    try {
      var routes = cartRoutes();
      var res = await fetch(routes.sections, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Section render failed');
      var json = await res.json();
      var html = json['cart-drawer'];
      if (!html) throw new Error('Missing cart-drawer section');

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = qs('[data-cart-drawer-root]', doc);
      var current = qs('[data-cart-drawer-root]');
      if (!next || !current) throw new Error('Missing drawer root');

      var wasOpen = isOpen();
      current.replaceWith(next);
      bindRoot(next);

      // Count from cart.js for accuracy
      var cartRes = await fetch(routes.cart, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      var cart = null;
      if (cartRes.ok) {
        cart = await cartRes.json();
        updateHeaderCount(cart.item_count || 0);
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: cart, source: 'cart-drawer' }
        })
      );

      if (openAfter || wasOpen) openDrawer();
    } catch (err) {
      console.error('[cart-drawer]', err);
    } finally {
      refreshing = false;
    }
  }

  async function postJson(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    var data = await res.json().catch(function () {
      return null;
    });
    if (!res.ok) {
      var msg =
        (data && (data.description || data.message)) ||
        'Could not update cart. Please try again.';
      throw new Error(msg);
    }
    return data;
  }

  async function addVariant(variantId, quantity) {
    var routes = cartRoutes();
    await postJson(routes.add, {
      items: [{ id: Number(variantId), quantity: quantity || 1 }]
    });
    await refreshDrawer(true);
  }

  async function changeLine(key, quantity) {
    var routes = cartRoutes();
    await postJson(routes.change, {
      id: key,
      quantity: Number(quantity)
    });
    await refreshDrawer(true);
  }

  async function submitProductForm(form) {
    var routes = cartRoutes();
    var fd = new FormData(form);
    var res = await fetch(routes.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: fd
    });
    var data = await res.json().catch(function () {
      return null;
    });
    if (!res.ok) {
      var msg =
        (data && (data.description || data.message)) ||
        'Could not add to cart. Please try again.';
      throw new Error(msg);
    }
    await refreshDrawer(true);
  }

  function onClick(e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeEl = e.target.closest('[data-cart-drawer-close]');
    if (closeEl || e.target.matches('[data-cart-drawer-overlay]')) {
      // Allow real links (e.g. Browse gallery) to navigate after closing
      if (!(closeEl && closeEl.tagName === 'A' && closeEl.getAttribute('href'))) {
        e.preventDefault();
      }
      closeDrawer();
      return;
    }

    var recNav = e.target.closest('[data-cart-recs-prev], [data-cart-recs-next]');
    if (recNav) {
      e.preventDefault();
      var track = recNav.closest('[data-cart-recs]');
      track = track && track.querySelector('[data-cart-recs-track]');
      if (track) {
        var dir = recNav.hasAttribute('data-cart-recs-next') ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      }
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-key');
      var qty = qtyBtn.getAttribute('data-qty');
      if (!key) return;
      qtyBtn.disabled = true;
      changeLine(key, qty).finally(function () {
        qtyBtn.disabled = false;
      });
      return;
    }

    var addBtn = e.target.closest('[data-cart-add]');
    if (addBtn) {
      e.preventDefault();
      if (
        addBtn.disabled ||
        addBtn.getAttribute('aria-disabled') === 'true' ||
        addBtn.getAttribute('data-available') === 'false'
      ) {
        return;
      }
      var card = addBtn.closest('[data-product-card]');
      if (card && card.getAttribute('data-product-available') === 'false') {
        return;
      }
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      addBtn.disabled = true;
      addVariant(variantId, 1)
        .catch(function (err) {
          window.alert(err.message);
        })
        .finally(function () {
          addBtn.disabled = false;
        });
    }
  }

  function onSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    var isProductAdd =
      form.matches('[data-product-form]') ||
      form.matches('form[action*="/cart/add"]') ||
      (action.indexOf('/cart/add') !== -1);
    if (!isProductAdd) return;

    e.preventDefault();
    if (
      form.getAttribute('data-available') === 'false' ||
      form.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }
    var btn = form.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('data-available') === 'false')) {
      return;
    }
    if (btn) btn.disabled = true;
    submitProductForm(form)
      .catch(function (err) {
        window.alert(err.message);
      })
      .finally(function () {
        if (btn && btn.getAttribute('data-available') !== 'false') btn.disabled = false;
      });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && isOpen()) {
      e.preventDefault();
      closeDrawer();
    }
  }

  function init() {
    bindRoot(qs('[data-cart-drawer-root]'));
    if (!root) return;

    document.addEventListener('click', onClick);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('keydown', onKeydown);

    // Expose for optional theme hooks (product cards, quick view, wishlist)
    window.OfficialCartDrawer = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshDrawer,
      add: addVariant
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
